/* eslint-disable no-underscore-dangle */

import { isEqual, isNil, isArray, isString, isEmpty, isObject, isFunction, cloneDeep, omit, pick, get } from 'lodash';
import TimerMixin from './TimerMixin';

// define a mixin object
export default {
  autosave: [],

  timers: {
    as__autosave: {
      time: 1000,
      autostart: true,
      repeat: true,
    },
  },

  mixins: [TimerMixin],

  data: function () {
    return {
      as__lastRunData: {},
      as__saveInProgress: {},
      as__pausedSaves: {},
      as__autosaveInit: {},
      as__autosaveFullInit: false,
      as__autosaveInitInterval: null,
      as__autosaveInitRetries: 0,
      as__autosaveInitInProgress: false,
      // as__autosaveInterval: null,
    };
  },

  created: function () {
    this.as__saveInProgress = {};
    this.as__pausedSaves = {};
    this.$serviceBus.$on('autosave', this.as__autosave);
    this.as__autosaveInitInterval = this.setInterval(this.as__init, 150);
    // this.as__autosaveInterval = this.setInterval(this.as__autosave, 1000);
    this.as__autosave();
  },

  mounted: function () {
    this.as__autosave();
  },

  beforeRouteLeave(to, from, next) {
    this.clearInterval(this.as__autosaveInitInterval);
    // this.clearInterval(this.as__autosaveInterval);
    this.as__autosave();
    next();
  },

  beforeDestroy: function () {
    this.clearInterval(this.as__autosaveInitInterval);
    // this.clearInterval(this.as__autosaveInterval);
    this.$serviceBus.$off('autosave', this.as__autosave);
    this.as__autosave();
  },

  methods: {
    as__pauseAutosave(name) {
      this.as__pausedSaves[name] = true;
    },
    as__continueAutosave(name) {
      this.as__updateLastRunData();
      this.as__pausedSaves[name] = false;
    },
    as__autosave() {
      if (isArray(this.$options.autosave)) {
        this.as__updateLastRunData();
      }
    },
    as__init() {
      if (this.as__autosaveFullInit === true || this.as__autosaveInitRetries > 25) {
        this.clearInterval(this.as__autosaveInitInterval);
      } else if (this.as__autosaveInitInProgress === false) {
        this.as__autosaveInitInProgress = true;
        try {
          this.as__updateLastRunData(true);
        } finally {
          this.as__autosaveInitInProgress = false;
          this.as__autosaveInitRetries++;
        }
      }
    },
    as__updateLastRunData(init) {
      const lastRunData = {};
      this.as__loopAutosaveOptions((it) => {
        const val = this[it.variable];

        if (!isEmpty(val)) {
          if (!isEmpty(it.exclude) && !isEmpty(it.include)) {
            lastRunData[it.name] = omit(pick(cloneDeep(val), it.include), it.exclude);
          } else if (!isEmpty(it.exclude) && isEmpty(it.include)) {
            lastRunData[it.name] = omit(cloneDeep(val), it.exclude);
          } else if (!isEmpty(it.include) && isEmpty(it.exclude)) {
            lastRunData[it.name] = pick(cloneDeep(val), it.include);
          } else if (isEmpty(it.include) && isEmpty(it.exclude)) {
            lastRunData[it.name] = cloneDeep(val);
          }
        } else {
          lastRunData[it.name] = null;
        }
      });

      // do not save if this function was called for init only (this is to ensure that we are not overloading anything by hitting 150ms save intervals
      if (init !== true) {
        // we need to build the lastRunData before checking for any changes to ensure that we don't miss any changes between triggering save and building the last run data
        if (!isEmpty(this.as__lastRunData)) {
          this.as__loopAutosaveOptions((it) => {
            if (get(this.as__saveInProgress, it.name, false) === true) {
              // make sure the change detection does trigger again next time
              lastRunData[it.name] = this.as__lastRunData[it.name];
            } else if (!isEmpty(this.as__lastRunData[it.name]) && !isEmpty(this[it.variable])) {
              if (!isEmpty(it.exclude) && !isEmpty(it.include) && !isEqual(this.as__lastRunData[it.name], omit(pick(this[it.variable], it.include), it.exclude))) {
                this.as__doSave(it);
              } else if (!isEmpty(it.exclude) && isEmpty(it.include) && !isEqual(this.as__lastRunData[it.name], omit(this[it.variable], it.exclude))) {
                this.as__doSave(it);
              } else if (!isEmpty(it.include) && isEmpty(it.exclude) && !isEqual(this.as__lastRunData[it.name], pick(this[it.variable], it.include))) {
                this.as__doSave(it);
              } else if (isEmpty(it.exclude) && isEmpty(it.include) && !isEqual(this.as__lastRunData[it.name], this[it.variable])) {
                this.as__doSave(it);
              }
            }
          });
        }
      }


      const $vm = this;
      this.as__loopAutosaveOptions((it) => {
        if (isNil($vm.as__autosaveInit[it.name])) {
          $vm.as__autosaveInit[it.name] = false;
        }

        if ($vm.as__autosaveInit[it.name] === false && !isNil(lastRunData[it.name])) {
          $vm.as__autosaveInit[it.name] = true;
          $vm.as__lastRunData[it.name] = lastRunData[it.name];
        }

        if ($vm.as__autosaveInit[it.name] === true) {
          $vm.as__lastRunData[it.name] = lastRunData[it.name];
        }
      });

      if (this.as__autosaveFullInit !== true) {
        this.as__autosaveFullInit = Object.values(this.as__autosaveInit).every(it => it === true);
      }
    },
    as__doSave(it) {
      if (this.as__pausedSaves[it.name] === true) return;

      const $vm = this;

      this.as__saveInProgress[it.name] = true;
      this.$store.commit('save/started', this._uid);
      const callback = () => {
        $vm.$store.commit('save/finished', this._uid);
        $vm.as__saveInProgress[it.name] = false;
        if (!isEmpty(it.event)) {
          $vm.$serviceBus.$emit(it.event);
        }
      };
      try {
        it.fn.call(this, callback);
      } catch (e) {
        this.$rollbar.error(e);
        this.axios.post(this.$serviceUrls.log.error, { error: e, user: this.$root.username, url: window.location.href, hotel: this.$root.hotel, date: new Date().toISOString() });
        this.showErrorMessage('Beim Speichern ist ein unerwarteter Fehler aufgetreten.');
        console.error(e);
        // to make sure we are not stuck in the save pending state
        callback();
      }
    },
    as__loopAutosaveOptions(fn) {
      this.$options.autosave.forEach((it) => {
        if (isObject(it) && isString(it.name) && isString(it.variable) && isFunction(it.fn)) {
          fn(it);
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/SaveWatchMixin.js